import { Activity } from 'react';
import { Column, Tab, TabPanel, Tabs } from '@tempmee/react';
import { useGetCandidateResume } from '~/domain/PermanentJobs';
import { IJob, IUser } from '~/models';
import { TNullable } from '~/types/Nullable';
import { CompetingOffersAlert, ExperienceSkillsPreview, ResumePreview } from '../../components';

interface IExperienceOverview {
  job?: TNullable<IJob>;
  postingId?: string;
  professional: TNullable<IUser>;
  hasWorkedWithDSO?: boolean;
  hasWorkedWithOffice?: boolean;
  competingOffersCount?: number;
}

export const ExperienceOverview = ({
  job,
  postingId,
  professional,
  hasWorkedWithDSO = false,
  hasWorkedWithOffice = false,
  competingOffersCount,
}: IExperienceOverview) => {
  const resolvedPostingId = postingId ?? job?.postingId;

  const { data: resume } = useGetCandidateResume(
    { professionalId: professional?.id || '', postingId: resolvedPostingId },
    { enabled: !!resolvedPostingId && !!professional?.id },
  );

  const hasGoTuResume = !!resume;

  return (
    <Column gap={4}>
      <CompetingOffersAlert count={competingOffersCount} />
      <Activity mode={hasGoTuResume ? 'visible' : 'hidden'}>
        <Tabs defaultValue="gotu-resume" style={{ alignItems: 'flex-start', gap: 16 }}>
          <Tab value="gotu-resume" label="GoTu Resume" />
          <Tab value="experience-skills" label="Experience & Skills" />
          <TabPanel value="gotu-resume" style={{ width: '100%' }}>
            <ResumePreview
              educations={(resume?.education || [])?.map((it) => ({
                graduatesAt: it.graduationDate,
                institutionName: it.institutionName,
              }))}
              experiences={(resume?.experiences || [])?.map((it) => ({
                employerName: it.employerName,
                endsAt: it.endDate,
                isCurrentEmployer: it.isCurrentEmployer,
                startsAt: it.startDate,
                title: it.title,
              }))}
              professionalName={resume?.professionalFirstName || ''}
              summaries={resume?.summary || ''}
            />
          </TabPanel>
          <TabPanel value="experience-skills" style={{ width: '100%' }}>
            <ExperienceSkillsPreview
              job={job}
              professional={professional}
              hasWorkedWithDSO={hasWorkedWithDSO}
              hasWorkedWithOffice={hasWorkedWithOffice}
            />
          </TabPanel>
        </Tabs>
      </Activity>
      <Activity mode={hasGoTuResume ? 'hidden' : 'visible'}>
        <ExperienceSkillsPreview
          job={job}
          professional={professional}
          hasWorkedWithDSO={hasWorkedWithDSO}
          hasWorkedWithOffice={hasWorkedWithOffice}
        />
      </Activity>
    </Column>
  );
};
